var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41667 13.0833H6.25V8.5H4.41667V13.0833ZM11.75 13.0833H13.5833V3.91667H11.75V13.0833ZM8.08333 13.0833H9.91667V10.3333H8.08333V13.0833ZM8.08333 8.5H9.91667V6.66667H8.08333V8.5ZM2.58333 16.75C2.07917 16.75 1.64757 16.5705 1.28854 16.2115C0.929514 15.8524 0.75 15.4208 0.75 14.9167V2.08333C0.75 1.57917 0.929514 1.14757 1.28854 0.788542C1.64757 0.429514 2.07917 0.25 2.58333 0.25H15.4167C15.9208 0.25 16.3524 0.429514 16.7115 0.788542C17.0705 1.14757 17.25 1.57917 17.25 2.08333V14.9167C17.25 15.4208 17.0705 15.8524 16.7115 16.2115C16.3524 16.5705 15.9208 16.75 15.4167 16.75H2.58333Z",
    fill: "#818194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.18ee748fa517b3351551e7ef5cce759b.svg";
export { ForwardRef as ReactComponent };